import CampaignFromInput from "./CampaignFromInput"

export default CampaignFromInput
